import React, { useRef, useEffect } from 'react';

function Canvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // 画像読み込みと描画のテスト
    const image = new Image();
    image.onload = () => {
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    };
    image.src = 'https://via.placeholder.com/400x300'; // 例：placeholder image
  }, []);

  return (
    <canvas ref={canvasRef} width={800} height={600} style={{ border: '1px solid #ccc' }} />
  );
}

export default Canvas;